<div class="adventages flex jc-sb mapfre-hide-mobile mapfre-hide-tablet">
    <div class="flex fd-col w-100 card" *ngFor="let ele of infoData">
        <div class="icon">
            <img [src]="'assets/icons/' + ele.icon + '.svg'" alt="">
        </div>
        <div class="mapfre-fs-s dark w-100 fw-500 title">{{ele.title | translate}}</div>
        <div class="mapfre-fs-s gray1 mapfre-mt-s">
            {{ele.text | translate}}
        </div>
    </div>
</div>
<div class="adventages mapfre-hide-desktop">
    <swiper [slidesPerView]="1" [spaceBetween]="32" *ngIf="infoData">
        <ng-template swiperSlide *ngFor="let ele of infoData">
            <div class="flex fd-col w-100 card">
                <div class="icon">
                    <img [src]="'assets/icons/' + ele.icon + '.svg'" alt="">
                </div>
                <div class="mapfre-fs-s dark w-100 fw-500">{{ele.title | translate}}</div>
                <div class="mapfre-fs-s gray1 mapfre-mt-s">
                    {{ele.text | translate}}
                </div>
            </div>
        </ng-template>
    </swiper>
</div>